import { Action } from '@/_core/fluxstore/types';
import { SlidePanelState } from '../types';

import { useAppSlidePanelModule } from '..';
const { registerReducer } = useAppSlidePanelModule();

export class OpenSlidePanel extends Action<SlidePanelState> {
    public static ACTION_TYPE = 'SlidePanelState::OpenSlidePanel';

    public constructor() {
        super(OpenSlidePanel.ACTION_TYPE);
    }
}

// eslint-disable-next-line
const reducer = (state: SlidePanelState, action: OpenSlidePanel): void => {
    state.isOpen = true;
};

//@ts-ignore
registerReducer(OpenSlidePanel.ACTION_TYPE, reducer);
